import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=a580e934"
import script from "./directory.vue?vue&type=script&lang=js"
export * from "./directory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports